/**
 * Sentry stub — initializes when REACT_APP_SENTRY_DSN is set.
 * Graceful no-op when DSN is missing or @sentry/react is not installed.
 */
export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  try {
    // Dynamic require keeps build working without @sentry/react installed
    // eslint-disable-next-line global-require
    const Sentry = require("@sentry/react");

    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV || "development",
      integrations: [
        Sentry.browserTracingIntegration?.(),
        Sentry.replayIntegration?.(),
      ].filter(Boolean),
      tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: process.env.NODE_ENV === "production" ? 1.0 : 0,
    });
  } catch {
    if (process.env.NODE_ENV === "development") {
      console.info("[sentry] REACT_APP_SENTRY_DSN set but @sentry/react not installed — skipping");
    }
  }
}

export function captureException(error, context) {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  try {
    // eslint-disable-next-line global-require
    const Sentry = require("@sentry/react");
    if (context) {
      Sentry.withScope((scope) => {
        Object.entries(context).forEach(([key, value]) => scope.setExtra(key, value));
        Sentry.captureException(error);
      });
    } else {
      Sentry.captureException(error);
    }
  } catch {
    // no-op
  }
}